import React, { useEffect, useState } from 'react'
import loadingSpin from "../images/loadingSpin.gif";
import { DataGrid } from '@mui/x-data-grid';
import Card from './common/Card';
import axios from 'axios';
import EmptyContent from "../components/common/EmptyContent";


export default function BillingDataTable() {
  const [loading, setLoading] = useState(false);
  const [history, setHistory] = useState([]);
  const [currency, setCurrency] = useState([]);
  const [fetchedNotes, setFetchedNotes] = useState([]);
  const [fetchError, setFetchError] = useState(false);

  const studentInfo = JSON.parse(localStorage.getItem('studentInfo'));
  const admissionnumber = studentInfo[0].admissionnumber;
  const schoolUrl = localStorage.getItem('schoolDomain');
  const idx = JSON.parse(localStorage.getItem('subSchoolData')).idx;
  const mobile = JSON.parse(localStorage.getItem('studentInfo'))[0].phonenumber

  useEffect(() => {
    getQuery()
  }, [])

  const getQuery = async () => {
    const PhoneNum = JSON.parse(localStorage.getItem("studentInfo"))[0]
      .admissionnumber;
    const data = {
      admission_number: PhoneNum,
    }

    setLoading(true)
    try {
      const response = await axios.post('https://edves.cloud/api/v1/payments/transactions/', data);
      console.log({ response });
      setHistory(response?.data?.transactions)
      // setCurrency(response?.data?.transactions[0]?.currency)
      response.data.data.paymentHistory.length > 0 && setFetchedNotes(response.data.data.paymentHistory[0].Available_Notes);
      setLoading(false)
    } catch (error) {
      console.log(error)
      setLoading(false)
      setFetchError(true);
    }
  }

  const columns = [
    //   {
    //     field: 'receiptLink',
    //     headerName: 'Action',
    //     width: 140,
    //     editable: false,
    //     cellClassName: 'actions',
    //     renderCell:(params)=>( <div className="bg-blue-900 block mx-auto">
    //     <a
    //         href={params.value}
    //         target='_blank'
    //         className="flex justify-center text-blue-100 text-xs font-semibold leading-3 p-2 cursor-pointer"
    //     >
    //       Download Receipt
    //     </a>
    // </div>)
    //   },
    {
      field: 'bill_id',
      headerName: 'Bill Name',
      width: 120,
      editable: false,
    },
    {
      field: 'fee_type',
      headerName: 'Bill Type',
      width: 120,
      editable: false,
    },

    {
      field: 'amount_paid',
      renderCell: (params) => Number(params.value).toLocaleString(undefined, { minimumFractionDigits: 2 }),
      headerName: `Amount Paid`,
      width: 130,
      editable: false,
    },
    {
      field: 'currency',
      headerName: 'Currency',
      width: 120,
      editable: false,
    },
    {
      field: 'created_at',
      headerName: 'Date',
      width: 120,
      editable: false,
    },
    {
      field: 'payment_status',
      headerName: 'Status',
      width: 140,
      editable: false,
    },
    {
      field: 'class',
      headerName: 'Class',
      width: 140,
      editable: false,
    },
    {
      field: 'payment_method',
      headerName: 'Payment Method',
      width: 140,
      editable: false,
    },

  ];

  return (
    <>
      {
        loading ?
          <div className='flex justify-center w-full h-full my-24'>
            <img src={loadingSpin} alt='loading...' />
          </div>
          :
          <Card>
            {
              fetchedNotes && fetchedNotes.length === 0 && !loading && !fetchError ?
                <div className='flex justify-center w-full sm:mt-16'>
                  <EmptyContent message='No Payment Found' moreMessage='Payment made will be displayed here' />
                </div> :
                <div style={{ height: 400, width: '100%' }}>
                  <DataGrid
                    rows={history}
                    columns={columns}
                    pageSize={5}
                    // noDataText={"No Payment Found"}
                    getRowId={(row) => row.id}
                  />
                </div>
            }

          </Card>
      }
    </>
  );
}
